import { ApiStatus } from "../types/api/status"
import { useDispatch, useSelector } from "../redux/store"
import { CustomSnackbar } from "../components/common/CustomSnackbar/CustomSnackbar"
import { readLocalStorage } from "../toolbox/helpers/local-storage-helpers"
import { LocalStorageKey } from "../types"
import { changeStatus, onFetchWayToPay, onSetSelectedWayToPay, selectWayToPayState, setAction } from "../redux/slices/wayToPaySlice"
import { WayToPay } from "../types/slices/wayToPayType"
import { WayToPayAPI } from "../apis/WayToPayAPI"

export const useWayToPayStore = () => {

    const dispatch = useDispatch()
    const { wayToPay, wayToPaySelected, status, action } = useSelector(selectWayToPayState)

    const userData = readLocalStorage(LocalStorageKey.USER_DATA)
    const idcompany = userData?.idcompany

    const getWayToPay = async (search='') => {
        try {
            dispatch(changeStatus(ApiStatus.FETCHING))
            const response = await WayToPayAPI.getWayToPay({search:search})
            if (!response?.status) {
                dispatch(changeStatus(ApiStatus.FETCHED))
                CustomSnackbar('error', response.data.message || "");
                return false; 
            }
            const { detail } = response.data
            dispatch(onFetchWayToPay(detail))
            dispatch(changeStatus(ApiStatus.FETCHED))
            return detail;
        } catch (error) {
            console.log(error)
            return dispatch(changeStatus(ApiStatus.FETCHED))
        }
    }

    const getWayToPayByCompany = async (search='') => {
        try {
            dispatch(changeStatus(ApiStatus.FETCHING))
            const response = await WayToPayAPI.getWayToPayByCompany({search:search, idcompany: idcompany})
            if (!response?.status) {
                dispatch(changeStatus(ApiStatus.FETCHED))
                CustomSnackbar('error', response.data.message || "");
                return false; 
            }
            const { detail } = response.data
            dispatch(onFetchWayToPay(detail))
            dispatch(changeStatus(ApiStatus.FETCHED))
            return detail;
        } catch (error) {
            console.log(error)
            return dispatch(changeStatus(ApiStatus.FETCHED))
        }
    }

    const getPaymentTools = async (search='') => {
        try {
            dispatch(changeStatus(ApiStatus.FETCHING))
            const response = await WayToPayAPI.getPaymentTools({search:search, idcompany: idcompany})
            if (!response?.status) {
                dispatch(changeStatus(ApiStatus.FETCHED))
                CustomSnackbar('error', response.data.message || "");
                return false; 
            }
            const { detail } = response.data
            dispatch(changeStatus(ApiStatus.FETCHED))
            return detail;
        } catch (error) {
            console.log(error)
            return dispatch(changeStatus(ApiStatus.FETCHED))
        }
    }

    const getPaymentCuotas = async (search='') => {
        try {
            dispatch(changeStatus(ApiStatus.FETCHING))
            const response = await WayToPayAPI.getPaymentCuotas({search:search, idcompany: idcompany})
            if (!response?.status) {
                dispatch(changeStatus(ApiStatus.FETCHED))
                CustomSnackbar('error', response.data.message || "");
                return false; 
            }
            const { detail } = response.data
            dispatch(changeStatus(ApiStatus.FETCHED))
            return detail;
        } catch (error) {
            console.log(error)
            return dispatch(changeStatus(ApiStatus.FETCHED))
        }
    }

    const setSelectedWayToPay= (waytopay: WayToPay) => {
        try {
            dispatch(onSetSelectedWayToPay(waytopay))
        } catch (error) {
            console.log(error)
        }
    }

    const setActionWayToPay = (state) => {
        try {
            dispatch(setAction(state))
        } catch (error) {
            console.log(error)
        }
    }

    return {
        //states
        wayToPay,
        wayToPaySelected,
        status,
        action,
        //actions
        getWayToPay,
        getWayToPayByCompany,
        getPaymentTools,
        getPaymentCuotas,
        setSelectedWayToPay,
        setActionWayToPay,
    }
}